import React, { Component } from 'react';
import TravelBudget1Page from './travel-budget1-html';
class TravelBudget1 extends Component {
    constructor(props) {
        super(props)
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }
    render() {
        return (
            <div>
                <TravelBudget1Page
                />
            </div>
        )
    }
}
export default TravelBudget1;